import styled from "styled-components";

export const UiModalTitle = styled.div`
	display: flex;
	align-items: center;
	column-gap: 6px;
	color: #1890ff;
`;

export const StyledSendMail = styled.div`
	color: #333;

	.infoRow {
		display: flex;
		margin-bottom: 12px;
	}

	.infoLabel {
		width: 90px;
		flex-shrink: 0;
	}

	.infoValue {
		word-break: break-all;
	}

	.warning {
		margin-top: 16px;
		color: #ff4d4f;
	}
`;
